interface Arguments {
  data: string;
  fileName: string;
  fileType: "excel" | "text" | "csv";
}

const dataTypes = {
  excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  text: "text/plain",
  csv: "text/plain",
};

const downloadData = ({ data, fileName, fileType }: Arguments) => {
  var element = document.createElement("a");
  element.setAttribute(
    "href",
    `data:${dataTypes[fileType]};charset=utf-8,` + encodeURIComponent(data)
  );
  element.setAttribute("download", fileName);

  element.style.display = "none";
  document.body.appendChild(element);

  element.click();

  document.body.removeChild(element);
};

export default downloadData;
